import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { INMTasacionesService } from '../../services/inmtasaciones.service';
import { CellHyperlinkCustomComponent } from '../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { CellImageFormatterComponent } from '../cell-image-formatter/cell-image-formatter.component'
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CurrencyFormatPipe } from '../../pipes/currency-format.pipe';
import { ApiResult } from './../../models/ApiResult';

@Component({
  selector: 'app-inmtasaciones',
  templateUrl: './inmtasaciones.component.html',
  styleUrls: ['./inmtasaciones.component.scss']
})
export class INMTasacionesComponent implements OnInit {

  public translate: TranslateService;
  public columnDefs: any[];
  public rowData: any;
  searchTerm: FormControl = new FormControl();
  public gridApi;

  private _rowsIdSelectedList: number[] = [];
  public mostarBoton:boolean = false;
  public rowsDelete:string;
  private _maxMostrar:number = 5;

  //mensajes
  public mensajeError:string = null;
  public mensajeCorrecto:string = null;



  constructor(private _INMTasacionesService: INMTasacionesService,private _router: Router, private _route: ActivatedRoute,
    public _authService: AuthService, private _translateService: TranslateService, private _currencyFormatPipe: CurrencyFormatPipe) {

    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();

  }

  createColumnDef() {
    const columnDefs = [
      { headerName: this.translate.instant('tasaciones.header_archivo'), field: 'nombreFicheroExcel', width: 230 },
      { headerName: this.translate.instant('tasaciones.header_codtasacion'), field: 'codigoTasacion', width: 120 },
      { headerName: this.translate.instant('tasaciones.npresupuesto'), field: 'nPresupuesto', width: 120 },
      { headerName: this.translate.instant('tasaciones.header_cliente'), field: 'clienteID', minWidth: 350 },
      { headerName: this.translate.instant('tasaciones.header_direccion'), field: 'dir_Direccion', minWidth: 350 },
      { headerName: this.translate.instant('tasaciones.header_localidad'), field: 'dir_Localidad', minWidth: 150 },
      { headerName: this.translate.instant('tasaciones.header_tipoInmueble'), field: 'tipoInmuebleId', minWidth: 120 },
      { headerName: this.translate.instant('tasaciones.header_finalidad'), field: 'finalidadId', minWidth: 120 },
      {
        headerName: this.translate.instant('tasaciones.header_fechaAlta'), field: 'createdDate',
        cellRendererFramework: CellDateFormatterComponent, minWidth: 90
      },
      { headerName: this.translate.instant('tasaciones.header_tecnico'), field: 'tecnicoID', minWidth: 90 },
      { headerName: this.translate.instant('tasaciones.header_estadoFacturado'), field: 'estadoConservacion', minWidth: 150 },
      { headerName: this.translate.instant('Valor Tacacion'),
        field: 'valorTasacion',
        minWidth: 100,
        valueFormatter: (data) => this._currencyFormatPipe.transform(data.value)  },
      { headerName: this.translate.instant('Superficie'), field: 'superficieConstruida', minWidth: 100},
      { headerName: this.translate.instant('Código postal'), field: 'dir_CodigoPostal', minWidth: 150},
      { headerName: this.translate.instant('Ano de construción'), field: 'anoConst', minWidth: 100},
    ];

    return columnDefs;
  }

  ngOnInit() {
    this.translate.use(this.translate.currentLang);
    this.getTasaciones();

    this.searchTerm.valueChanges.pipe(debounceTime(400)).subscribe(data => {
      this.getTasaciones();
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  public getTasaciones() {
    let svc: Observable<any>;

    if (this.searchTerm.value != null) {
      svc = this._INMTasacionesService.getINMTasacionesFiltered(this.searchTerm.value);
    } else {
      svc = this._INMTasacionesService.getINMTasaciones();
    }

    svc.subscribe(data => {
      this.rowData = data;      
    }, (err) => {
      console.error('Error al recuperar datos de clientes');
    });
  }

  public onRowClicked(e) {
    if (e.event.target !== undefined) {
      const data = e.data;
      const actionType = e.event.target.getAttribute('data-action-type');

      //switch (actionType) {
      //  case 'remove':
      //    return this.onActionRemoveClick(data);

      //}
    }
  }

  getSelectedItems(e) {

    var selected = this.gridApi.getSelectedNodes();    

    if(selected.length >= 0)
    {
      this.mostarBoton = true;
    }
    
    let valrows:any[]=[];   
    var selectedString = '';   
    var max = this._maxMostrar;

    selected.forEach(function(selectedRow, index)
    {        
      valrows.push(selectedRow.data.id);              
    });

    selectedString = ' + ' + valrows.length.toString();
    
    this._rowsIdSelectedList = valrows;
    this.rowsDelete = selectedString;

    // console.log(selectedString);
      
    console.log(this._rowsIdSelectedList);

}

closeAlertCorrecto() {
    
  this.mensajeCorrecto = null;    
}

closeAlertIncorrecto() {
  
  this.mensajeError = null;
}

cerrarBoton()
{
   this.closeAlertCorrecto();
   this.closeAlertIncorrecto();
   this._rowsIdSelectedList = null;   
   this.gridApi.deselectAll();
   this.mostarBoton = false;
}


public borrarTasaciones()
{
  if(this._rowsIdSelectedList.length)
  {
    this.mostarBoton = false;
    var ans = confirm("Quieres eliminar " + this.rowsDelete + " seleccionados" );
    if (ans) {      
      this._INMTasacionesService.deleteTasaciones(this._rowsIdSelectedList)
      .subscribe({
        next: (apiResult: ApiResult) => {
          if (apiResult.correct) {        
            this.mensajeCorrecto = apiResult.mensaje;              
            this.ngOnInit();
          }
          else {
            this.mensajeError = apiResult.mensaje;
          }
        },
        error: (error) => {

        }
      });
    }
  }

}

}
